module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/YNj4ne/tc-custom/9781524881627.jpg?1733121316591",
      "alt": "This image is the cover for the book Along the Way"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Along the Way\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Appealing to both the person in the pew and professional minister, "), _c('i', [_vm._v("Along the Way: The Life, Lessons, and Legacy of Father Hugh F. Crean")]), _vm._v(" explores the legacy of Vatican II (1962-1965) and its unfinished agenda. Written by a diverse group of contributors, including noted Church historian David O’Brien and sociologist Mary Johnson, SNDdeN, the essays included in "), _c('i', [_vm._v("Along the Way")]), _vm._v(" challenge readers to reconsider the essence and form of priesthood, religious life, and ministry while pointing to themes Crean delivered throughout his 53 years of ministry."), _c('br'), _vm._v(" "), _c('br'), _vm._v("The book was prepared under the auspices of the Saint Augustine Center for Ethics, Religion, and Culture at the College of Our Lady of the Elms in Chicopee, Massachusetts, where Crean served as a faculty member."), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mark S. Stelzer\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0